import { SVGProps, Ref, forwardRef } from 'react';

export const MetroStationSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <circle cx={12} cy={12} r={5} fill="currentColor" />
    </svg>
));
MetroStationSize24Glyph.displayName = 'MetroStationSize24Glyph';
